import { ColumnDef, flexRender, getCoreRowModel, useReactTable } from '@tanstack/react-table';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Typography } from '@/components';
import { getWidthClass } from '@/helpers/table-columns-width';
import { myOppsColumns } from './my-opps-column-header';
import { Opportunity } from '../table/types';
import { MyOpportunitiesRow } from './my-opps-row';

export function MyOpportunitiesTable({ opportunities }: any) {
  const columns: ColumnDef<Opportunity>[] = myOppsColumns();

  const table = useReactTable({
    data: opportunities,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className="bg-neutral-10 overflow-x-auto rounded-md border-2 border-neutral-50">
      <Table className="w-full min-w-175 lg:min-w-0">
        <TableHeader>
          {table.getHeaderGroups().map((headerGroup) => (
            <TableRow key={headerGroup.id} className="hover:bg-muted border-neutral-100">
              {headerGroup.headers.map((header) => {
                const widthClass = getWidthClass('asSeller', header.column.id);
                return (
                  <TableHead key={header.id} className={`px-3 py-4 ${widthClass}`}>
                    <Typography as="h6" size="body-2" weight="semibold" className="whitespace-nowrap text-neutral-500">
                      {header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}
                    </Typography>
                  </TableHead>
                );
              })}
            </TableRow>
          ))}
        </TableHeader>
        <TableBody>
          {table.getRowModel().rows?.length ? (
            table.getRowModel().rows.map((row) => <MyOpportunitiesRow key={row.id} row={row} />)
          ) : (
            <TableRow>
              <TableCell colSpan={columns.length} className="h-24 text-center">
                No results.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
}
